var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 257,
    viewBox: "0 0 212 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_5405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6425 157.566C128.232 158.666 158.785 129.896 159.885 93.3067C160.985 56.7174 132.216 26.1642 95.6263 25.0641C59.037 23.964 28.4838 52.7337 27.3837 89.3229C26.2836 125.912 55.0533 156.465 91.6425 157.566Z",
    fill: "#F1F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.471 178.635C102.867 179.356 98.1754 179.716 93.4234 179.703C69.8148 179.645 47.6389 170.398 30.9846 153.665C14.3272 136.931 5.18748 114.712 5.24189 91.1005C5.2993 67.4919 14.5463 45.316 31.2799 28.6617C48.0166 12.0075 70.2352 2.86775 93.8439 2.92207C117.452 2.97948 139.628 12.2265 156.283 28.9601C172.937 45.6937 182.08 67.9124 182.022 91.5241C181.965 115.133 172.718 137.309 155.984 153.963C142.617 167.265 125.748 175.777 107.468 178.635L107.471 178.635ZM81.7321 16.2059C66.0066 18.6643 51.5016 25.9829 40.0016 37.4269C25.6076 51.7521 17.6536 70.8255 17.6057 91.1352C17.5578 111.445 25.4212 130.555 39.7465 144.949C54.0717 159.343 73.1451 167.297 93.4548 167.345C113.762 167.393 132.874 159.532 147.269 145.204C161.663 130.879 169.617 111.806 169.665 91.4958C169.712 71.186 161.849 52.0761 147.524 37.682C133.198 23.2879 114.125 15.3339 93.8154 15.286C89.7311 15.2776 85.693 15.586 81.7321 16.2059V16.2059Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0373 103.858L43.835 103.749L43.8205 110.017L91.0229 110.126L91.0373 103.858Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6045 83.3533L64.3369 83.3378L64.2198 130.543L70.4874 130.559L70.6045 83.3533Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.998 62.0885L85.796 61.9797L85.7816 68.2474L132.984 68.3562L132.998 62.0885Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.573 41.591L106.305 41.5754L106.188 88.7809L112.456 88.7964L112.573 41.591Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.794 146.606L148.656 151.721C145.901 154.463 145.891 158.919 148.633 161.673L158.073 171.158C160.815 173.912 165.271 173.923 168.026 171.181L173.164 166.066C175.919 163.324 175.929 158.868 173.187 156.114L163.746 146.629C161.004 143.875 156.549 143.864 153.794 146.606Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.599 166.505L168.474 168.62C164.888 172.191 164.874 177.993 168.444 181.579L239.582 253.046C243.152 256.633 248.954 256.646 252.541 253.076L254.666 250.961C258.253 247.39 258.266 241.588 254.696 238.002L183.558 166.535C179.988 162.948 174.186 162.935 170.599 166.505Z",
    fill: "#82BCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_5405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256.651,
    height: 248.199,
    fill: "white",
    transform: "translate(7.94003 0.307678) rotate(1.72213)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.206de269b4b5efcd3238ce2062b008ca.svg";
export { ForwardRef as ReactComponent };